/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 draws a browser-share pie.`)
};

const es_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 dibuja un gráfico de cuota de navegadores.`)
};

const de_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 zeichnet ein Kreisdiagramm zum Browseranteil.`)
};

const nl_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 tekent een browserverdelingscirkeldiagram.`)
};

const fr_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 dessine un diagramme de parts de navigateurs.`)
};

const it_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 disegna una torta delle quote di browser.`)
};

const pt_br2_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 desenha uma pizza de participação de navegadores.`)
};

const pt_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 desenha um gráfico circular de quota de navegadores.`)
};

const ja_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 でブラウザシェアの円グラフが描画されます。`)
};

const zh_pie_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63 / Safari,20 / Edge,5 绘制出浏览器份额饼图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_ex1", locale)
	if (locale === "en") return en_pie_ex1(inputs)
	if (locale === "es") return es_pie_ex1(inputs)
	if (locale === "de") return de_pie_ex1(inputs)
	if (locale === "nl") return nl_pie_ex1(inputs)
	if (locale === "fr") return fr_pie_ex1(inputs)
	if (locale === "it") return it_pie_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pie_ex1(inputs)
	if (locale === "pt") return pt_pie_ex1(inputs)
	if (locale === "ja") return ja_pie_ex1(inputs)
	return zh_pie_ex1(inputs)
};